// extracted by mini-css-extract-plugin
module.exports = {"col_box":"col_box-FyIuEBLQ","col_navlist":"col_navlist-HrPa9HDM"};